module.exports = __webpack_public_path__ + "static/img/204.70371e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200608/204.jpg
// module id = UY4J
// module chunks = 0